module.exports = __webpack_public_path__ + "static/media/sf-test-3.a63e02ee.mp3";